(function () {
  if (window.__productPageCheckoutWeightLockInit) return;
  window.__productPageCheckoutWeightLockInit = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|select|clear)(\.js)?(\?|$|\/)/;

  const PRODUCT_CHECKOUT_BUTTON_SELECTORS = [
    '.product-form__buttons .shopify-payment-button__button',
    '.product-form__buttons [data-shopify="payment-button"]',
    '.product-form__buttons [data-shopify="payment-button"] button',
    '.product-form__buttons button[name="checkout"]',
    '.product-form__buttons #checkout',
  ];

  const PRODUCT_DYNAMIC_CHECKOUT_WRAPPERS = [
    '.product-form__buttons .shopify-payment-button',
    '.product-form__buttons [data-shopify="payment-button"]',
  ];

  const NOTICE_SELECTORS = ['#DeliveryServiceNoticeProduct'];
  const LOCK_CLASS = 'checkout-weight-lock--disabled';

  const PRODUCT_CONTAINER_IDS = ['DeliveryServiceProductContainer', 'DeliveryServiceProductContainer2'];

  function getServices() {
    const els = document.querySelectorAll('[data-delivery-service-config]');
    if (!els.length) return null;

    const merged = new Map();

    els.forEach((el) => {
      let parsed;
      try {
        parsed = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }

      if (parsed && Array.isArray(parsed.services)) {
        parsed.services.forEach((service) => {
          if (service && service.key && service.variantId != null && !merged.has(service.key)) {
            merged.set(service.key, service);
          }
        });
      }
    });

    return merged.size ? Array.from(merged.values()) : null;
  }

  function queryAllUnique(selectors) {
    const found = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (found.indexOf(el) === -1) found.push(el);
      });
    });

    return found;
  }

  function isAnyServiceInCart(cartData, services) {
    if (!cartData || !Array.isArray(cartData.items)) return false;

    return services.some((service) =>
      cartData.items.some((item) => String(item.variant_id) === String(service.variantId))
    );
  }

  function isOverAnyThreshold(cartData, services) {
    if (!cartData || typeof cartData.total_weight !== 'number') return false;

    return services.some((service) => {
      return typeof service.thresholdGrams === 'number' && cartData.total_weight > service.thresholdGrams;
    });
  }

  function applyButtonState(el, isLocked) {
    if (!el) return;

    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT' || el.tagName === 'A') {
      el.disabled = isLocked;
      el.setAttribute('aria-disabled', isLocked ? 'true' : 'false');
    }

    if (el.classList) {
      el.classList.toggle(LOCK_CLASS, isLocked);
    }

    if (el.style) {
      el.style.pointerEvents = isLocked ? 'none' : '';
      el.style.opacity = isLocked ? '0.5' : '';
      el.style.filter = isLocked ? 'grayscale(0.15)' : '';
    }
  }

  function setProductCheckoutLock(isLocked) {
    queryAllUnique(PRODUCT_CHECKOUT_BUTTON_SELECTORS).forEach((button) => {
      applyButtonState(button, isLocked);
    });

    queryAllUnique(PRODUCT_DYNAMIC_CHECKOUT_WRAPPERS).forEach((wrapper) => {
      wrapper.classList.toggle(LOCK_CLASS, isLocked);
      wrapper.setAttribute('aria-hidden', isLocked ? 'true' : 'false');
      wrapper.hidden = isLocked;
      wrapper.style.display = isLocked ? 'none' : '';
      wrapper.style.pointerEvents = isLocked ? 'none' : '';
      wrapper.style.opacity = isLocked ? '0.5' : '';
      wrapper.style.filter = isLocked ? 'grayscale(0.15)' : '';

      wrapper.querySelectorAll('button, input, a, shop-pay-wallet-button, more-payment-options-link, shopify-accelerated-checkout').forEach((nestedElement) => {
        applyButtonState(nestedElement, isLocked);
      });
    });
  }

  function setProductNoticeVisibility(showNotice) {
    queryAllUnique(NOTICE_SELECTORS).forEach((notice) => {
      notice.classList.toggle('hidden', !showNotice);
      notice.setAttribute('aria-hidden', showNotice ? 'false' : 'true');
    });
  }

  function getProductPageContainerId(service) {
    return service.key === 'service_2' ? 'DeliveryServiceProductContainer2' : 'DeliveryServiceProductContainer';
  }

  function getProductPageInputId(service) {
    return service.key === 'service_2' ? 'DeliveryServiceProductInput2' : 'DeliveryServiceProductInput';
  }

  function renderOfferMarkup(service, cartData, serviceList) {
    const blockedByExclusivity = serviceList.some((candidate) => {
      if (candidate.key === service.key) return false;
      return cartData.items.some((item) => String(item.variant_id) === String(candidate.variantId));
    });

    const overThreshold = typeof cartData.total_weight === 'number' && cartData.total_weight > service.thresholdGrams;
    const shouldRender = overThreshold && !blockedByExclusivity;
    const serviceIsInCart = cartData.items.some((item) => String(item.variant_id) === String(service.variantId));
    const containerId = getProductPageContainerId(service);
    const container = document.getElementById(containerId);

    if (!container) return;

    if (!shouldRender) {
      container.innerHTML = '';
      return;
    }

    const inputId = getProductPageInputId(service);
    const markup = [
      '<delivery-service-checkbox class="delivery-service-checkbox product-delivery-service-checkbox" data-variant-id="' + service.variantId + '" data-service-key="' + service.key + '">',
      '<label class="delivery-service-checkbox__label" for="' + inputId + '">',
      '<input type="checkbox" id="' + inputId + '" class="delivery-service-checkbox__input" data-delivery-service-input ' + (serviceIsInCart ? 'checked' : '') + '>',
      '<span class="delivery-service-checkbox__content">',
      '<span class="delivery-service-checkbox__title">' + (service.label || 'Add delivery service') + '</span>',
      (service.description ? '<span class="delivery-service-checkbox__description-wrap product-delivery-service-checkbox__description-wrap" data-description-wrap data-product-description-wrap><span class="delivery-service-checkbox__description product-delivery-service-checkbox__description" data-description-text data-product-description-text>' + service.description + '</span></span><button type="button" class="delivery-service-checkbox__toggle product-delivery-service-checkbox__toggle" data-description-toggle data-product-description-toggle data-show-more-label="' + (service.showMoreLabel || 'Show more') + '" data-show-less-label="' + (service.showLessLabel || 'Show less') + '" aria-expanded="false" hidden><span data-toggle-label data-product-toggle-label>' + (service.showMoreLabel || 'Show more') + '</span><svg class="delivery-service-checkbox__toggle-icon product-delivery-service-checkbox__toggle-icon" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' : ''),
      '</span>',
      '</label>',
      '<div class="delivery-service-checkbox__spinner hidden" data-delivery-service-spinner><svg aria-hidden="true" focusable="false" role="presentation" class="icon-loading-spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>',
      '</delivery-service-checkbox>'
    ].join('');

    container.innerHTML = markup;
  }

  function syncProductOfferUI(cartData) {
    const services = getServices();
    if (!services || !cartData || !Array.isArray(cartData.items)) return;

    services.forEach((service) => {
      renderOfferMarkup(service, cartData, services);
    });
  }

  function evaluateCart(cartData) {
    const services = getServices();

    if (!services || !cartData || typeof cartData.total_weight !== 'number') {
      setProductCheckoutLock(false);
      setProductNoticeVisibility(false);
      return;
    }

    const overThreshold = isOverAnyThreshold(cartData, services);
    const anyServiceSelected = isAnyServiceInCart(cartData, services);
    const shouldLock = overThreshold && !anyServiceSelected;

    setProductCheckoutLock(shouldLock);
    setProductNoticeVisibility(shouldLock);
    syncProductOfferUI(cartData);
  }

  function fetchLiveCartAndEvaluate() {
    fetch(`${ROOT}cart.js`, { cache: 'no-store' })
      .then((res) => res.json())
      .then((cart) => evaluateCart(cart))
      .catch(() => {});
  }

  function handleMutationResponseData(data) {
    if (data && typeof data.total_weight === 'number') {
      evaluateCart(data);
      return;
    }

    fetchLiveCartAndEvaluate();
  }

  function installFetchInterceptor() {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartMutation = CART_MUTATION_PATTERN.test(url);

      return originalFetch.apply(this, args).then((response) => {
        if (isCartMutation && response.ok) {
          response
            .clone()
            .json()
            .then((data) => handleMutationResponseData(data))
            .catch(() => {});
        }

        return response;
      });
    };
  }

  function installXhrInterceptor() {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__productPageCheckoutWeightLockIsCartMutation = CART_MUTATION_PATTERN.test(String(url));
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      if (this.__productPageCheckoutWeightLockIsCartMutation) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            try {
              handleMutationResponseData(JSON.parse(this.responseText));
            } catch (e) {
              /* ignore */
            }
          }
        });
      }

      return originalSend.apply(this, args);
    };
  }

  function init() {
    installFetchInterceptor();
    installXhrInterceptor();
    fetchLiveCartAndEvaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
